module.exports = __webpack_public_path__ + "img/4w.c8c34aa3.svg";